import {inject, Injectable, resource} from '@angular/core';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {CompteComptableDTO} from '../../dtos/compte-comptable-dto';
import {HttpService} from '../technique/http.service';
import {GraphQLService} from '../technique/graphql.service';
import {Auth2Service} from '../security/auth2.service';
import {ResponseWrapper} from '../../suppliers/wrappers/response-wrapper';

@Injectable({providedIn: 'root'})
export class CompteComptableService {

  private readonly httpSvc = inject(HttpService);
  private readonly graphQlSvc = inject(GraphQLService);
  private readonly auth2Svc = inject(Auth2Service);

  readonly comptesComptablesResource = resource<CompteComptableDTO[], void>({
    loader: async () => {
      const siteIds = this.auth2Svc.utilisateur.sites.map(s => s.id);
      const response: any = await this.graphQlSvc.sendQuery(`
        {
          allCompteComptables(filters: { siteIdList: [${siteIds}] }) {
            id, code, libelle, facture, variationStock, stock, actif,
            site { id, libelle }
          }
        }
      `).pipe(take(1)).toPromise();
      return (response?.allCompteComptables ?? []) as CompteComptableDTO[];
    }
  });

  delete = (ids: number[]): Observable<any> =>
    this.httpSvc.delete(`dolrest/referentiel/compte-comptable/delete?ids=${ids.join(',')}`);

  save = (dto: CompteComptableDTO): Observable<ResponseWrapper<CompteComptableDTO>> =>
    this.httpSvc.post('dolrest/referentiel/compte-comptable/save', dto);

  canModify = (dto: CompteComptableDTO): boolean => {
    if (!dto?.site?.id || dto.site.id === 0) { return true; }
    return this.auth2Svc.isSiteLocal(dto.site.id);
  };
}
